import { render } from "./searchacc.vue?vue&type=template&id=44f1f652&scoped=true"
import script from "./searchacc.vue?vue&type=script&lang=js"
export * from "./searchacc.vue?vue&type=script&lang=js"

import "./searchacc.vue?vue&type=style&index=0&id=44f1f652&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f1f652"]])

export default __exports__